import React, { useEffect, useState } from 'react';
import { Row, Col, message } from 'antd';
import ListCard from 'Molecules/ListCard';
import HeadingChip from 'Molecules/HeadingChip';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getStockBalances } from '../ducks/actions'
import { exportStockBalance } from '../ducks/services'
import Search from './components/Search'
import dayjs from 'dayjs';
import AllRoles from '../../../../routing/config/AllRoles';
import { allowed } from '../../../../routing/config/utils';
import { getListQueryItems } from 'Modules/Application/ducks/actions';
import { comma } from 'Features/utility';
import { useTranslate } from 'Translate';

const filters = [
  {
    label: "Stock Balance Report",
    value: "payment"
  },
  {
    label: "Stock Balance (Email)",
    value: "email"
  },
]

export default (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const stockBalances = useSelector((state) => state.reporting.stockBalances);
  const meta = useSelector((state) => state.reporting.option);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [searchVal, setSearchVal] = useState(null);
  const [outlets, setOutlets] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [selected, setSelected] = useState(filters[0].value);
  const [isExport, setIsExport] = useState(false);
  const i18n = useTranslate();
  const { t } = i18n;

  const productOptions = meta?.item_products?.map(item => ({label: `${item.code} - ${item.name}`, value: item.id})) || [];

  const colName = [
    {
      title: t("Outlet.outlet"),
      dataIndex: 'location_desc',
      key: 'location_desc',
      width: 200,
      fixed: 'left',
      render: (text, record) => <span><b>{text ? `${record.location_code} - ${text}` : ""}</b></span>
    },
    {
      title: t("General.item"),
      dataIndex: 'desc',
      key: 'desc',
      width: 250,
      fixed: 'left',
      render: (text, record) => <span>{(text == "Grand Total" || text == "Sub Total") ? text : `${record.code} - ${text}`}</span>
    },
    {
      title: t("General.uom"),
      dataIndex: 'uom_code',
      key: 'uom_code',
      width: 100,
      fixed: 'left',
      render: (text) => <span><b>{text ? text : ""}</b></span>
    },
    {
      title: t("InvReporting.opening"),
      children: [
        {
          title: t("General.qty_dot"),
          dataIndex: 'opening_qty',
          key: 'opening_qty',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(5))}</span>
        },
        {
          title: t("Inventory.inv_dot_cost"),
          dataIndex: 'opening_cost',
          key: 'opening_cost',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(8))}</span>
        },
        {
          title: t("Inventory.inv_unit_cost"),
          dataIndex: 'opening_unit_cost',
          key: 'opening_unit_cost',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(8))}</span>
        },
      ],
    },
    {
      title: t("InvReporting.grn_gr_note"),
      children: [
        {
          title: t("General.qty_dot"),
          dataIndex: 'stock_in_qty',
          key: 'stock_in_qty',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(5))}</span>
        },
        {
          title: t("Inventory.inv_dot_cost"),
          dataIndex: 'stock_in_cost',
          key: 'stock_in_cost',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(8))}</span>
        },
        {
          title: t("Inventory.inv_unit_cost"),
          dataIndex: 'stock_in_unit_cost',
          key: 'stock_in_unit_cost',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(8))}</span>
        },
      ],
    },
    {
      title: t("InvReporting.ilt_int_trans"),
      children: [
        {
          title: t("General.qty_dot"),
          dataIndex: 'transfer_qty',
          key: 'transfer_qty',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(5))}</span>
        },
        {
          title: t("Inventory.inv_dot_cost"),
          dataIndex: 'transfer_cost',
          key: 'transfer_cost',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(8))}</span>
        },
        {
          title: t("Inventory.inv_unit_cost"),
          dataIndex: 'transfer_unit_cost',
          key: 'transfer_unit_cost',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(8))}</span>
        },
      ],
    },
    {
      title: t("InvReporting.posbm_pos_bom"),
      children: [
        {
          title: t("General.qty_dot"),
          dataIndex: 'sales_qty',
          key: 'sales_qty',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(5))}</span>
        },
        {
          title: t("Inventory.inv_dot_cost"),
          dataIndex: 'sales_cost',
          key: 'sales_cost',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(8))}</span>
        },
        {
          title: t("Inventory.inv_unit_cost"),
          dataIndex: 'sales_unit_cost',
          key: 'sales_unit_cost',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(8))}</span>
        },
      ],
    },
    {
      title: t("InvReporting.conv_stock_conv"),
      children: [
        {
          title: t("General.qty_dot"),
          dataIndex: 'stock_conversion_qty',
          key: 'stock_conversion_qty',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(5))}</span>
        },
        {
          title: t("Inventory.inv_dot_cost"),
          dataIndex: 'stock_conversion_cost',
          key: 'stock_conversion_cost',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(8))}</span>
        },
        {
          title: t("Inventory.inv_unit_cost"),
          dataIndex: 'stock_conversion_unit_cost',
          key: 'stock_conversion_unit_cost',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(8))}</span>
        },
      ],
    },
    {
      title: t("InvReporting.was_stock_wastage"),
      children: [
        {
          title: t("General.qty_dot"),
          dataIndex: 'stock_wastage_qty',
          key: 'stock_wastage_qty',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(5))}</span>
        },
        {
          title: t("Inventory.inv_dot_cost"),
          dataIndex: 'stock_wastage_cost',
          key: 'stock_wastage_cost',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(8))}</span>
        },
        {
          title: t("Inventory.inv_unit_cost"),
          dataIndex: 'stock_wastage_unit_cost',
          key: 'stock_wastage_unit_cost',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(8))}</span>
        },
      ],
    },
    {
      title: t("InvReporting.adj"),
      children: [
        {
          title: t("General.qty_dot"),
          dataIndex: 'adjustment_qty',
          key: 'adjustment_qty',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(5))}</span>
        },
        {
          title: t("Inventory.inv_dot_cost"),
          dataIndex: 'adjustment_cost',
          key: 'adjustment_cost',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(8))}</span>
        },
        {
          title: t("Inventory.inv_unit_cost"),
          dataIndex: 'adjustment_unit_cost',
          key: 'adjustment_unit_cost',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(8))}</span>
        },
      ],
    },
    {
      title: t("InvReporting.stake_st"),
      children: [
        {
          title: t("General.qty_dot"),
          dataIndex: 'stock_take_qty',
          key: 'stock_take_qty',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(5))}</span>
        },
        {
          title: t("Inventory.inv_dot_cost"),
          dataIndex: 'stock_take_cost',
          key: 'stock_take_cost',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(8))}</span>
        },
        {
          title: t("Inventory.inv_unit_cost"),
          dataIndex: 'stock_take_unit_cost',
          key: 'stock_take_unit_cost',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(8))}</span>
        },
      ],
    },
    {
      title: t("InvReporting.closing"),
      children: [
        {
          title: t("General.qty_dot"),
          dataIndex: 'closing_qty',
          key: 'closing_qty',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(5))}</span>
        },
        {
          title: t("Inventory.inv_dot_cost"),
          dataIndex: 'closing_cost',
          key: 'closing_cost',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(8))}</span>
        },
        {
          title: t("Inventory.inv_unit_cost"),
          dataIndex: 'closing_unit_cost',
          key: 'closing_unit_cost',
          width: 200,
          align: 'right',
          render: (text) => <span>{comma(parseFloat(text).toFixed(8))}</span>
        },
      ],
    },
    // {
    //   title: 'Closing Adjustment Cost',
    //   dataIndex: 'adjustment_cost',
    //   key: 'adjustment_cost',
    //   align: 'right',
    //   width: 300,
    //   render: (text) => <span>{comma(parseFloat(text).toFixed(8))}</span>
    // }
  ];

  const dropSelection = {
    value: selected,
    onAction: (e) => setSelected(e),
    options: filters
  };

  useEffect(() => {
    dispatch(getStockBalances(null, props.setLoading, true));
  }, []);

  useEffect(() => {
    if(meta) {
      if('outlets' in meta) {
        let temp = [];
        meta.outlets.map((x, ind) => {
          temp.push({
            label: `${x.code} ${x.desc}`,
            value: x.id
          })
        });
        setOutlets(temp);
      }
    }
    if(stockBalances && 'list' in stockBalances) {
      let temp = [];
      const dataKeys = {
        adjustment_cost: 0,
        adjustment_qty: 0,
        adjustment_unit_cost: 0,
        closing_cost: 0,
        closing_qty: 0,
        closing_unit_cost: 0,
        opening_cost: 0,
        opening_qty: 0,
        opening_unit_cost: 0,
        sales_cost: 0,
        sales_qty: 0,
        sales_unit_cost: 0,
        stock_conversion_cost: 0,
        stock_conversion_qty: 0,
        stock_conversion_unit_cost: 0,
        stock_in_cost: 0,
        stock_in_qty: 0,
        stock_in_unit_cost: 0,
        stock_take_cost: 0,
        stock_take_qty: 0,
        stock_take_unit_cost: 0,
        stock_wastage_cost: 0,
        stock_wastage_qty: 0,
        stock_wastage_unit_cost: 0,
        transfer_cost: 0,
        transfer_qty: 0,
        transfer_unit_cost: 0
      }
      let grandTotal = {
        ...dataKeys
      };
      stockBalances?.list?.forEach((itemList) => {
        if(itemList.length > 0) {
          let locationSubTotal = {
            desc: "Sub Total",
            ...dataKeys
          }

          itemList.forEach(item => {
            temp.push(item);
            Object.keys(item).forEach(key => {
              if (!["id", "code", "desc", "uom_code", "location_code", "location_desc"].includes(key)) locationSubTotal[key] += parseFloat(item[key])
            })
          });

          if (stockBalances?.list?.filter(x => x?.length > 0)?.length > 1) temp.push(locationSubTotal);

          Object.keys(locationSubTotal).forEach(key => {
            if (key !== "desc") grandTotal[key] += parseFloat(locationSubTotal[key])
          })
        }
      });

      temp.push({
        desc: "Grand Total",
        ...grandTotal
      });
      
      setReportData(temp);
    }
  }, [stockBalances, meta]);

  const exportReport = async (payload) => {
    // if (stockBalances?.total_count === 0) {
    //   return message.warning(t("General.no_data_export"));
    // }
    props.setLoading(true);

    await exportStockBalance(payload, selected).then((res) => {
      props.setLoading(false);
      if (res.data) {
        const aElement = document.createElement('a');
        let filename = res.headers["x-filename"];
        aElement.setAttribute('download', filename ?? "sample.pdf");
        const href = URL.createObjectURL(res.data);
        aElement.href = href;
        aElement.setAttribute('target', '_blank');
        aElement.click();
        URL.revokeObjectURL(href);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const btnList = [
    {
      text: t("General.export_report"),
      classes: 'green-btn',
      form: "stock-balance-filter",
      isExport: true,
      action: () => setIsExport(true)
    }
  ];

  // const onTableChange = (pagination, filters, sorter) => {
  //   setPage(pagination.current);
  //   setLimit(pagination.pageSize);
  //   if (sorter.order) {
  //     dispatch(getStockBalances(pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading));
  //   } else {
  //     dispatch(getStockBalances(pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading));
  //   }
  // }

  const onSearch = async (search) => {
    setPage(1);
    if (search) {
      let searching = {};
      let temp = [];
      if (search?.outlets?.length > 0) {
        search?.outlets?.map(x => {
          temp.push(x.value)
        });
      }
      searching = {
        products: search?.products?.length > 0 ? JSON.stringify(search?.products?.map(item => item.value)) : undefined,
        start_date: search.start_date ? dayjs(search.start_date).format("YYYY-MM-DD") : "",
        end_date: search.end_date ? dayjs(search.end_date).format("YYYY-MM-DD") : "",
        outlets: temp.length > 0 ? JSON.stringify(temp) : null
      };

      if(isExport) {
        await exportReport(searching)
      } else {
        setSearchVal(searching);
        dispatch(getStockBalances(searching, props.setLoading));
      }
    } else {
      setSearchVal(null);
      dispatch(getStockBalances(null, props.setLoading));
    }
  };

  const onSubmit = (val) => {
    onSearch(val);
  }

  const rowClassName = (record, index) => {
    return record?.desc == "Sub Total" || record?.desc == "Grand Total" ? 'summary-row' : '';
  };

  return (
    <Row gutter={[10, 10]}>
      <Col span={24}>
        <HeadingChip title={t("General.stock_bal")} drop={dropSelection} btnList={allowed([AllRoles.INVENTORY_REPORTING.STOCK_BALANCE], 'write') ? btnList : null} />
      </Col>
      {/* refer to csv table layout */}
      <Col span={24} className="inv-report-sb">
        <ListCard
          isSticky={true}
          scrolling={reportData?.length ? 4000 : 1000}
          Search={Search}
          onSearch={onSearch}
          bordered={true}
          // listClass="nopad"
          ListData={reportData?.map((x, index) => ({ ...x, key: index }))}
          rowClassName={rowClassName}
          ListCol={colName}
          field1={outlets}
          field2={productOptions}
          pagination={false}
          showHeader={reportData?.length ? true : false}
          setIsExport={setIsExport}
          onSubmit={onSubmit}
        />
      </Col>
    </Row>
  )
}